<p-toast></p-toast>
<p-card styleClass="p-card-shadow mt-2">
    <div class="card dashboardTable">
        <p-toolbar styleClass="mb-4">
            <ng-template pTemplate="left">
                <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                    class="p-button-success"></button> -->
                <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
            </ng-template>
            <ng-template pTemplate="right">
                <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
                <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
                    class="p-button-help"></button>
               
                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </ng-template>    
        </p-toolbar>
        <p-table #miSurvey [value]="vendorWise"  dataKey="AppId_ProgID"
        [rows]="10"
        [paginator]="true" [globalFilterFields]="[
        'VendorName',
        'ChallanGenerated',
        'ChallanAmount',
        'ChallanDeposited',
        'AmountDeposited',

        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true"
        (onFilter)="tableDataFunction($event)"
        (onPage)="onPage($event)" [loading]="loading">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <h5 class="m-0">{{'VENDOR_WISE_REPORT'| translate}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text"
                        (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="{{'SEARCH'| translate}}" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                             
                <th pSortableColumn="VendorName">{{'VENDOR_NAME'| translate}}
                    <p-columnFilter type="text" field="VendorName" display="menu"></p-columnFilter>
                    <p-sortIcon field="VendorName"></p-sortIcon>
                </th>
                <th pSortableColumn="ChallanGenerated">{{'CHALLAN_GENERATED'| translate}}
                    <p-columnFilter type="text" field="ChallanGenerated" display="menu"></p-columnFilter>
                    <p-sortIcon field="ChallanGenerated"></p-sortIcon>
                </th>
                <th pSortableColumn="ChallanAmount">{{'CHALLAN_AMOUNT'| translate}}
                    <p-columnFilter type="text" field="ChallanAmount" display="menu"></p-columnFilter>
                    <p-sortIcon field="ChallanAmount"></p-sortIcon>
                </th>
                <th pSortableColumn="ChallanDeposited">{{'CHALLAN_DEPOSITED'| translate}}
                    <p-columnFilter type="text" field="ChallanDeposited" display="menu"></p-columnFilter>
                    <p-sortIcon field="ChallanDeposited"></p-sortIcon>
                </th>
                <th pSortableColumn="AmountDeposited">{{'AMOUNT_DEPOSITED'| translate}}
                    <p-columnFilter type="text" field="AmountDeposited" display="menu"></p-columnFilter>
                    <p-sortIcon field="AmountDeposited"></p-sortIcon>
                </th>
            
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-vendorWise>
            <tr>
                <td>{{vendorWise.VendorName}}</td>
                <td><a class="link_pointer" (click)="showMaximizableDialog_challan('Challan',vendorWise.Vendor_Code,vendorWise.VendorName)">{{vendorWise.ChallanGenerated}}</a></td>
                <td>{{vendorWise.ChallanAmount}}</td>
                <td><a class="link_pointer" (click)="showMaximizableDialog_challan('ChallanDeposited',vendorWise.Vendor_Code,vendorWise.VendorName)">{{vendorWise.ChallanDeposited}}</a></td>
                <td>{{vendorWise.AmountDeposited}}</td>
                
            </tr>
        </ng-template>
        <ng-template pTemplate="footer">
            <tr>
                <td >  Total</td>
                <td >{{challanGenerated | number:'1.0-2'}}</td>
                <td >{{challanAmount | number:'1.0-2'}}</td>
                <td >{{challanDeposited | number:'1.0-2'}}</td>
                <td >{{amountDeposited | number:'1.0-2'}}</td>
            </tr>
            <tr>
                <td > Grand Total</td>
                <td >{{grandChallanGenerated | number:'1.0-2'}}</td>
                <td >{{grandChallanAmount | number:'1.0-2'}}</td>
                <td >{{grandChallanDeposited | number:'1.0-2'}}</td>
                <td >{{grandAmountDeposited | number:'1.0-2'}}</td>
            </tr>
        </ng-template>
    
        </p-table>
    </div>
    </p-card>
    <p-dialog  class="drilldown_details" [baseZIndex]="-100" header="Drill Down Vendor wise {{challanName}} Report Of  {{vendorName}} "  [(visible)]="displayMaximizable" [modal]="true" [style]="{width: '100%'}"  
   [draggable]="false" [resizable]="false" >
   
   <app-challan-drill-down-report  *ngIf="displayMaximizable" [drilldownDetails]="drilldownDetails"></app-challan-drill-down-report>
   
  </p-dialog>